<template>
<div>
  <div class="columns">
      <div class="column">
        <text-input 
          required
          :value="checkpoint.value"
          :error="$root.errorBag.value"
          @input="updateValue"
          placeholder="Password length must be at least 8 characters">
          Title
        </text-input>
      </div>
      <div class="column">
        <select-input 
          required
          :items="riskLevels"
          :error="$root.errorBag.risk_level"
          :value="checkpoint.risk_level"
          @input="updateRiskLevel">
          Risk Level
        </select-input>
      </div>
      <div class="column">
        <data-selector 
          required
          :items="cwes"
          label-key="number"
          value-key="id"
          :value="checkpoint.cwe_id"
          :error="$root.errorBag.cwe_id"
          @input="updateCwe">
          CWE
        </data-selector>
      </div>
    </div>
    <submit-button 
      @submit="saveCheckpoint"
      :working="working"
      left-icon="save">Save</submit-button>
</div>
</template>
<script>
import { createCheckpoint } from '@/api/super'
import { getPath } from '@/api/common'
import { mapGetters, mapMutations } from 'vuex'

export default {

  data: () => ({
    working: false,
    cwes: []
  }),

  beforeCreate() {
    getPath({
      path: '/api/super/cwe-list'
    }, ({data}) => {
      this.cwes = data
    }, error => {})
  },

  methods: {
    ...mapMutations('checkpoint', [
      'updateValue',
      'updateCwe',
      'setAssessor',
      'updateRiskLevel'
    ]),
    saveCheckpoint() {
      createCheckpoint(this.checkpoint, ({data}) => {
        this.$toast.success('checkpoint created')
        this.$router.push({
          name: 'checkpoints'
        });
      }).catch(error => {
        this.$toast.error('try again')
      })
    }
  },

  computed: {
    ...mapGetters('checkpoint', [
      'checkpoint',
      'riskLevels'
    ])
  }

}
</script>
